import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

type MobileContextType = {
  isMobile: boolean;
  isOpenSiderbar: boolean;
  toggleSiderbar: () => void;
};

const MobileContext = createContext<MobileContextType | undefined>(undefined);

export function MobileProvider({ children }: { children: ReactNode }) {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);
  const [isOpenSiderbar, setIsOpenSiderbar] = useState<boolean>(false);

  const toggleSiderbar = () => {
    setIsOpenSiderbar((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <MobileContext.Provider
      value={{ isMobile, isOpenSiderbar, toggleSiderbar }}
    >
      {children}
    </MobileContext.Provider>
  );
}

export function useMobile() {
  const context = useContext(MobileContext);
  if (!context) {
    throw new Error("useMobile deve ser usado dentro de um MobileProvider");
  }
  return context;
}
